import { ContentTypeTag, FeedType } from '../../models';
import useFetchPaginatedArticles from './useFetchPaginatedArticles';

interface DefaultArticleList {
  isFetching: boolean;
  hasResults: boolean | undefined;
}

export default (feedType: FeedType): DefaultArticleList => {
  const articlesQuery = useFetchPaginatedArticles(
    FeedType.My,
    100,
    1,
    {},
    [ContentTypeTag.Research, ContentTypeTag.Covenants, ContentTypeTag.News],
    undefined,
    feedType === FeedType.My
  );

  return {
    isFetching: articlesQuery.isFetching,
    hasResults: !!articlesQuery.totalResults,
  };
};
